import React, { useMemo } from 'react';

/**
 * Lightweight SVG sparkline. Accepts a 1–60-point series.
 * Renders an orange-to-green gradient line + dot at the latest point.
 */
export const Sparkline = ({ data = [], width = 220, height = 56, accentA = '#FF6B1A', accentB = '#39FF14' }) => {
  const { path, dx, dy, lastX, lastY } = useMemo(() => {
    if (!data.length) return { path: '', dx: 0, dy: 0, lastX: 0, lastY: 0 };
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const stepX = (width - 8) / Math.max(1, data.length - 1);
    const pts = data.map((v, i) => [4 + i * stepX, height - 4 - ((v - min) / range) * (height - 12)]);
    const p = pts.reduce((acc, [x, y], i) => acc + (i === 0 ? `M${x},${y}` : ` L${x},${y}`), '');
    return { path: p, dx: 0, dy: 0, lastX: pts[pts.length - 1][0], lastY: pts[pts.length - 1][1] };
  }, [data, width, height]);

  if (!data.length) {
    return <svg width={width} height={height} aria-hidden />;
  }
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden>
      <defs>
        <linearGradient id="spark-grad" x1="0%" x2="100%">
          <stop offset="0%" stopColor={accentA} />
          <stop offset="100%" stopColor={accentB} />
        </linearGradient>
        <linearGradient id="spark-fill" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stopColor={accentA} stopOpacity="0.25" />
          <stop offset="100%" stopColor={accentA} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${path} L ${width - 4},${height} L 4,${height} Z`} fill="url(#spark-fill)" />
      <path d={path} fill="none" stroke="url(#spark-grad)" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lastX} cy={lastY} r="3.5" fill={accentB} stroke="#0B0F17" strokeWidth="1.5" />
    </svg>
  );
};
